import SearchHelper from "@/utils/SearchHelper";
import React, { useEffect } from "react";
import SearchForm from "./SearchInputs";

export const SideAdvancedSearch = ({ queryParams }) => {
  useEffect(() => {
    (async () => {})();
  }, []);

  return (
    <div className="lg:col-span-4 md:col-span-6">
      <div className="shadow p-6 rounded-xl bg-white  sticky top-20">
        <SearchForm queryParams={queryParams} container="sidebar" />
      </div>
    </div>
  );
};
